export default __webpack_public_path__ + "static/media/bbaUSDT.cc182b7d.png";